import React, {useEffect} from 'react'
import { Route } from 'react-router-dom'
import {MemoryRouter, useHistory} from 'react-router'
import { PersistGate } from 'redux-persist/integration/react'
import { Provider } from 'react-redux'
import * as ls from 'local-storage'
import ClearIcon from '@material-ui/icons/Clear'

import { JobBoardPage } from 'pages/dentist/JobBoardPage'
import { JobBoardDetailsPage } from 'pages/dentist/JobBoardDetailsPage'
import CandidatePage from 'pages/dentist/CandidatePage'
import JobPostFeedbackPage from 'pages/dentist/JobPostFeedbackPage'
import CandidateResumePage from 'pages/dentist/CandidateResumePage'
import JobDeleteSuccessPage from 'pages/dentist/JobDeleteSuccessPage'

import EditJobPostFirstStep from 'pages/dentist/EditJobPostFirstStep'
import EditJobPostSecondStep from 'pages/dentist/EditJobPostSecondStep'
import EditJobPostOverviewStep from 'pages/dentist/EditJobPostOverviewStep'

import EditJobPostPositionPage from 'pages/dentist/EditJobPostPositionPage'
import EditJobPostOfficeLocationPage from 'pages/dentist/EditJobPostOfficeLocationPage'
import EditJobPostAvailabilityPage from 'pages/dentist/EditJobPostAvailabilityPage'
import EditJobPostDatesPage from 'pages/dentist/EditJobPostDatesPage'
import EditJobPostCandidateRequirementsPage from 'pages/dentist/EditJobPostCandidateRequirementsPage'
import EditJobPostTitleDescriptionPage from 'pages/dentist/EditJobPostTitleDescriptionPage'
import EditJobPostConfirmationPage from 'pages/dentist/EditJobPostConfirmationPage'
import EditJobPostSuccessPage from 'pages/dentist/EditJobPostSuccessPage'
import CustomOfferDetailsPage from 'pages/dentist/CustomOfferDetailsPage'

import PostJob from "./pages/dentist/PostJobPage";

import AvailableJobsPage from 'pages/hygienist/AvailableJobsPage'
import JobPostsListPage from 'pages/hygienist/JobPostsListPage'
import JobPostDetailsPage from 'pages/hygienist/JobPostDetailsPage'
import PartialOfferPage from "./pages/hygienist/PartialOfferPage";
import AvailableJobPage from "./pages/hygienist/AvailableJobPage";
import ConfirmedOfferPage from "./pages/hygienist/ConfirmedOfferPage";
import HygienistInvoicePage from "./pages/hygienist/InvoicePage/Invoice";
import ContactSupport from "./pages/hygienist/ContactSupport";
import DOContactSupport from 'pages/dentist/ContactSupport'

import HygienistDeleteAccount from 'pages/hygienist/DeleteAccount'
import DentistDeleteAccount from 'pages/dentist/DeleteAccount'

import MarketingMessaging from "./pages/landing/MarketingMessaging";
import ForgotPassword from "./pages/landing/ForgotPassword"
import ResetPassword from "./pages/landing/ResetPassword"
import Login from "./pages/landing/Login";
import RoleSelect from "./pages/landing/RoleSelect";
import SignUp0 from './pages/landing/SignUp0'
import SignUp1_DO from './pages/landing/SignUp1_DO'
import SignUp2_DO from "./pages/landing/SignUp2_DO";
import SignUp1_Talent from './pages/landing/SignUp1_Talent'
import SignUp2_Talent from './pages/landing/SignUp2_Talent'
import Onboarding_DO from './pages/landing/Onboarding_DO'
import Onboarding_Talent from './pages/landing/Onboarding_Talent'
import SignUp_PaymentInfo from './pages/landing/SignUp_PaymentInfo'

import createStore, { entities } from 'reduxStore'
import {usePersistedState} from 'hooks'
import Api from "./api";
import {roles} from "utils/constants";
import Landing from "./pages/landing/Landing";
import _ from "lodash";
import {HygienistProps, UserAccountProps} from "./utils/types";
import InvoicePage from "./pages/dentist/InvoicePage";
import CustomOfferPage from "./pages/dentist/CustomOfferPage";
import CustomOffersPage from "./pages/dentist/CustomOffersPage";

import DentistConfirmedOfferPage from "./pages/dentist/ConfirmedOfferPage";
import ModifyJobPage from "./pages/dentist/ModifyJobPage";
import ProfilePage from "./pages/hygienist/ProfilePage";
import Download from "./pages/landing/Download";
import JobInfoPage from 'components/JobBoardDetails/JobInfo/JobInfo'
import HygienistDeleteAccountSecondStep from 'pages/hygienist/DeleteAccountSecondStep'
import CancelJobPage from "./pages/hygienist/CancelJobPage";
import JobPostedPage from "./pages/dentist/JobPostedPage/JobPostedPage";
import { MyStats } from "./pages/hygienist/MyStatsPage";
import FeedbackPage from "./pages/dentist/FeedbackPage/FeedbackPage";
import HygienistFeedbackPage from "./pages/hygienist/FeedbackPage";
import { createTheme, ThemeProvider } from '@mui/material'

const { store, persistor } = createStore()

// @ts-ignore
const app = window?.app;

export interface PageDataProps {
	page: string,
	date?: string,
}

const DefaultRoute = () => {
	const history = useHistory();
	const [loading, setLoading] = React.useState<boolean>(false)
	const setUser = usePersistedState({
		entityName: entities.user,
	})[1];

	const setDentistUser = usePersistedState({
		entityName: entities.dentistUser,
	})[1];

	const setHygienist = usePersistedState({
		entityName: entities.hygienist,
	})[1]

	let user = usePersistedState<UserAccountProps>({
		entityName: entities.user
	})[0];

	let hygienist = usePersistedState<HygienistProps>({
		entityName: entities.hygienist
	})[0];

	const getRoute = async (userAccount?: UserAccountProps, pageData?: PageDataProps) => {
		if (pageData && ['RoleSelect', 'Login', 'landing', 'loading', 'Download', 'SignUp0', 'SignUp1_DO'].includes(pageData.page)) {
			if (pageData.page === 'SignUp1_DO') {
				await Api.updateToken();
			}
			return pageData.page;
		}
		try {
			if (Number.isInteger(userAccount?.hygienistId) && !!userAccount?.hygienist?.isComplete) {
				return pageData?.page || 'jobPostsList';
			} else if (Number.isInteger(userAccount?.dentistId)) {
				return pageData?.page || 'jobBoard';
			} else if (userAccount?.email?.length) {
				if (!!userAccount?.hygienistId && !!userAccount?.hygienist?.firstName) {
					return 'SignUp2_Talent';
				} else {
					const { roleId } = await Api.getRole()
					return roleId === roles.DENTIST ? 'SignUp1_DO' : 'SignUp1_Talent';
				}
			}
		} catch (e) {
			console.log('Error getting role and user', e);
			return 'landing';
		}
		return 'landing';
	};

	const handleStorageChange = async () => {
		setLoading(true)
		const data = ls.get<PageDataProps>('pageData');
		const jwt = ls.get('userAuth');

		if (data) {
			ls.remove('pageData');

			if (jwt) {
				if(!user || !hygienist) {
					user = ls.get<UserAccountProps>('userAccount')
					if (_.isEmpty(user)) {
						user = await Api.getUser()
					}
					ls.set<UserAccountProps>('userAccount', user as UserAccountProps)
					setUser(user);
					if (user?.hygienist) {
						setHygienist(user?.hygienist);
					}
					if (user?.dentist) {
						setDentistUser(user)
					}
				} else {
					user = ls.get<UserAccountProps>('userAccount')
					if(!_.isEmpty(user)){
						setUser(user);
						if (user?.hygienist) {
							setHygienist(user?.hygienist);
						}
						if (user?.dentist) {
							setDentistUser(user)
						}
					}
				}

				getRoute(user, data).then((page) => {
					setLoading(false)
					history.push({ pathname: page, state: { ...data } });
				});
			} else {
				getRoute(undefined, data).then((page) => {
					setLoading(false)
					history.push({ pathname: page, state: { ...data }  });
				});
			}
		}
		setLoading(false)
	};

	useEffect(() => {
		window.addEventListener('storage', handleStorageChange, false);
	}, []);

	return loading ? <div className="background">
		Redirecting...
	</div> : null;
};

function App() {
	const [pageData] = React.useState<PageDataProps>(ls.get<PageDataProps>('pageData'))
	ls.remove('pageData');
	let countryCode = 'CA';

	app?.hidePreloader();

	const THEME = createTheme({
		typography: {
			fontFamily: [
				'Poppins',
				'sans-serif',
			  ].join(','),
		}
	 });

	return (
		<ThemeProvider theme={THEME}>
		<Provider store={store}>
			<PersistGate loading={null} persistor={persistor}>
				<MemoryRouter
					initialEntries={['landing']}
				>
					<DefaultRoute/>
					<SaveData
						countryCode={countryCode}
					/>

					<Route path={'landing'} component={Landing}/>

					{/* Dentist Routes */}
					<Route path={'jobBoard'} component={JobBoardPage}/>
					<Route path={'jobBoardDetails'} component={JobBoardDetailsPage}/>
					<Route path={'jobInfo'} component={JobInfoPage}/>
					<Route path={'candidate'} component={CandidatePage}/>
					<Route path={'candidateResume'} component={CandidateResumePage}/>
					<Route path={'jobFeedback'} component={JobPostFeedbackPage}/>
					<Route path={'deleteSuccess'} component={JobDeleteSuccessPage}/>
					<Route path={'postPosition'} component={EditJobPostPositionPage}/>
					<Route path={'postOfficeLocation'} component={EditJobPostOfficeLocationPage}/>
					<Route path={'postAvailability'} component={EditJobPostAvailabilityPage}/>
					<Route path={'postDates'} component={EditJobPostDatesPage}/>
					<Route path={'postCandidateRequirements'} component={EditJobPostCandidateRequirementsPage}/>
					<Route path={'postTitleDescription'} component={EditJobPostTitleDescriptionPage}/>
					<Route path={'postConfirmation'} component={EditJobPostConfirmationPage}/>
					<Route path={'postSuccess'} component={EditJobPostSuccessPage}/>
					<Route path={'customOfferDetails'} component={CustomOfferDetailsPage}/>
					<Route path={'dentistCustomOffers'} component={CustomOffersPage}/>
					<Route path={'hygienistCancelJob'} component={CancelJobPage}/>
					<Route path={'jobPosted'} component={JobPostedPage}/>
					<Route path={'feedbackPage'} component={FeedbackPage}/>
					
					{/* New Edit Job Routes */}
					<Route path={'editJobFirstStep'} component={EditJobPostFirstStep}/>
					<Route path={'editJobSecondStep'} component={EditJobPostSecondStep}/>
					<Route path={'editJobOverviewStep'} component={EditJobPostOverviewStep}/>

					<Route path={'SignUp_PaymentInfo'} component={SignUp_PaymentInfo}/>

					<Route path={'postJob'} component={PostJob}/>
					<Route path={'invoice'} component={InvoicePage}/>
					<Route path={'dentistJobConfirmed'} component={DentistConfirmedOfferPage}/>
					<Route path={'customOffer'} component={CustomOfferPage}/>
					<Route path={'modifyJob'} component={ModifyJobPage}/>
					<Route path={'hygienistContactSupport'} component={ContactSupport}/>
					<Route path={'dentistContactSupport'} component={DOContactSupport}/>

					{/* Delete Account Route */}
					<Route path={'hygienistDeleteAccount'} component={HygienistDeleteAccount}/>
					<Route path={'hygienistDeleteAccountSecondStep'} component={HygienistDeleteAccountSecondStep}/>

					<Route path={'dentistDeleteAccount'} component={DentistDeleteAccount}/>

					{/* Hygienist Routes */}
					<Route path={'availableJobs'} component={AvailableJobsPage}/>
					<Route path={'availableJob'} component={AvailableJobPage}/>
					<Route path={'partialOffer'} component={PartialOfferPage}/>
					<Route path={'confirmedOffer'} component={ConfirmedOfferPage}/>
					<Route path={'hygienistProfile'} component={ProfilePage}/>
					<Route path={'hygienistInvoice'} component={HygienistInvoicePage}/>
					<Route path={'myStats'} component={MyStats}/>
					<Route path={'hygienistFeedback'} component={HygienistFeedbackPage}/>
					<Route path={'hygienist/feedback'} component={HygienistFeedbackPage}/>

					{/* ASSOCIATE DENTIST Home Route */}
					<Route path={'jobPostsList'} component={JobPostsListPage}/>
					<Route path={'jobPostDetails'} component={JobPostDetailsPage}/>

					{/* Landing Routes */}
					<Route path={'MarketingMessaging'} component={MarketingMessaging}/>
					<Route path={'ForgotPassword'} component={ForgotPassword}/>
					<Route path={'ResetPassword'} component={ResetPassword}/>
					<Route path={'Login'} component={Login}/>
					<Route path={'RoleSelect'} component={RoleSelect}/>
					<Route path={'SignUp0'} component={SignUp0}/>
					<Route path={'SignUp1_DO'} component={SignUp1_DO}/>
					<Route path={'SignUp2_DO'} component={SignUp2_DO}/>
					<Route path={'SignUp1_Talent'} component={SignUp1_Talent}/>
					<Route path={'SignUp2_Talent'} component={SignUp2_Talent}/>
					<Route path={'Onboarding_DO'} component={Onboarding_DO}/>
					<Route path={'Onboarding_Talent'} component={Onboarding_Talent}/>
					<Route path={'Download'} component={Download}/>

					{/* Loading Route */}

					<Route path={'loading'}>
						<div className="background">
							Page redirecting...
						</div>
					</Route>
					{/*<Route path="*">*/}
					{/*	<div className="background">*/}
					{/*		Loading...*/}
					{/*	</div>*/}
					{/*</Route>*/}
				</MemoryRouter>
			</PersistGate>
			{/* This thing serves absolutely no reason.
			 However, every route should have at least one @material-ui
			 element in it's tree, otherwise the production build fails
			 for some reason with some strange errors after
			 being embedded into the root Cordova project 🤷‍
			 If you're reading this, press F. */}
			<ClearIcon style={{display: 'none'}}/>
		</Provider>
		</ThemeProvider>
	);
}

function SaveData({countryCode}: { countryCode: string }) {
	const setCountry = usePersistedState({
		entityName: entities.countryCode,
	})[1]
	useEffect(() => {
		setCountry(countryCode)
	}, [setCountry, countryCode])
	return null
}

export default App